import API from 'utils/api';
import { onError } from 'utils/handlers';
import getFormattedValues, { hasFiles } from 'utils/formatValues';

export const baseURI = 'catalogos/dato-operacional-del-becario/';

const getValuesAndConfig = (values) => {
  const files = ['firma', 'sello'];
  const config = hasFiles(values, files) ? {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  } : {};
  const formattedValues = getFormattedValues(values, {
    files,
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Datos Operacionales Del Becarios
 * @returns {Promise<object[]>}
 */
export const getDatoOperacionalesDeBecarios = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Dato Operacional Del Becario
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getDatoOperacionalDelBecario = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Dato Operacional Del Becario
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDatoOperacionalDelBecario = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    // onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Dato Operacional Del Becario
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDatoOperacionalDelBecario = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    // onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Dato Operacional Del Becario
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteDatoOperacionalDelBecario = async (id) => {
  try {
    // eslint-disable-next-line no-unused-vars
    const response = await API.delete(`${baseURI}/${id}`);
    // onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Dato Operacional Del Becario por ID de empleado
 * @param {number} empleadoId
 * @returns {Promise<object|null>}
 */
export const getDatoOperacionalPorBecario = async (becarioId) => {
  try {
    const response = await API.get(baseURI, {
      params: { becario: becarioId },
    });
    const { data } = response;
    if (Array.isArray(data)) return data[0] || null;
    return data || null;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * GET Plazas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDatoOperacionalPorBecarioOptimized = async (params) => {
  try {
    const response = await API.get('/catalogos/dato-operacional-del-becario-vista-optimized/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
